export default __webpack_public_path__ + "static/media/percentage-icon-green.c36f7043.svg";